export default "__VITE_ASSET__BuUOmcD8__"